import { BaseConverter } from '@/util/number'

/**
 * @deprecated  新規の利用は禁止. short idが必要ならlong idから変換するのではなく直接 short id を使えば良い.
 * @see https://github.com/my-color/front/pull/6490#pullrequestreview-978069513
 * @param longId
 */
export function convertLongIdToShortId(longId: string): string {
  const positionBeginOfShortId = -5

  return longId.split('-').slice(positionBeginOfShortId).join('-')
}

export function convertShortIdToDisplayId(shortId: string): string {
  return BaseConverter.convertBaseFrom16To62(shortId.replace(/-/g, ''))
}

export function convertLongIdToDisplayId(longId: string): string {
  const shortId = convertLongIdToShortId(longId)

  return convertShortIdToDisplayId(shortId)
}
